import React from 'react'
import { Link } from "react-router-dom";


const Activities = () => {
    return (
        <>

            <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
                <div className="container">
                    <div className="row">
                        <div className="page-heading">
                            <h2 className="wow fadeInUp" data-wow-delay=".3s">Our Activities</h2>
                            <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li><i className="fa-solid fa-chevron-right" /></li>
                                <li>Our Activities</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="choose-us-section pb-0 section-bg fix bg-cover" style={{ backgroundImage: 'url(assets/img/choose-us/bg-1.png)', marginTop: "-90px" }}>
                <div className="container">
                    <div className="choose-us-wrapper">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/gallery/Sports and Athletics.jpg" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">
                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Sports and Athletics
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            We provide a thorough sports curriculum that fosters the growth of kids' physical prowess, sportsmanship, and collaboration. Students are able to participate in a variety of sports, including football, basketball, cricket, swimming, and athletics, thanks to our well-equipped sports facilities and knowledgeable trainers.
                                        </p>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="row g-4 align-items-center mt-lg-5">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/gallery/Arts and Culture.jpg" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">

                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Arts and Culture
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            In order to foster creativity and self-expression, the arts are essential. Through arts like dance, music, theater, painting, and sculpting, our school offers a dynamic setting for children to discover their creative abilities. To highlight their creative accomplishments, we regularly host exhibitions and performances.
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="row g-4 align-items-center mt-lg-5">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/gallery/Clubs and Societies.jpg" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">
                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Clubs and Societies
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            We provide a large selection of clubs and societies to suit a variety of hobbies and interests. Clubs including robotics, computing, photography, debating, environmental conservation, and community service are available for students to join. Students can explore their interests, learn new skills, and work on worthwhile projects with the help of these clubs.
                                        </p>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="row g-4 align-items-center mt-lg-5">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/gallery/Competitions and Events.jpg" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">

                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Competitions and Events
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            We encourage our pupils to take part in a variety of intra- and inter-school events and competitions. These consist include sporting events, science fairs, art contests, academic quizzes, and cultural festivals. These kinds of activities help our students develop a spirit of accomplishment, healthy competition, and teamwork.
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <div className="row g-4 align-items-center mt-lg-5">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/Library.JFIF" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">

                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Library
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            Books, movies, recorded sound, magazines, realia, and digital media are all found at school libraries, just like in public libraries. These resources are intended to improve and broaden the school curriculum in addition to providing entertainment, education, and enjoyment for all members of the school community.
                                        </p>
                                    </div>

                                </div>
                            </div>

                        </div> */}
                    </div>
                </div>
            </section>

        </>
    )
}

export default Activities